var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 23.15 11.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc43e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.64,.87c.93,.49,1.64,1.18,2.15,2.07,.51,.89,.76,1.91,.76,3.07s-.25,2.17-.76,3.06c-.51,.89-1.23,1.58-2.16,2.07-.93,.49-2.01,.74-3.24,.74H0V.13H4.4c1.24,0,2.32,.25,3.25,.74Zm-.9,7.64c.6-.59,.9-1.43,.9-2.51s-.3-1.92-.9-2.53-1.44-.9-2.53-.9h-1.35v6.82h1.35c1.08,0,1.92-.3,2.53-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.43,2.89c.5-.91,1.2-1.62,2.1-2.12s1.92-.76,3.05-.76c1.39,0,2.59,.37,3.58,1.1,.99,.74,1.66,1.74,1.99,3.01h-3.14c-.23-.49-.57-.86-1-1.12-.43-.26-.92-.38-1.46-.38-.88,0-1.59,.31-2.14,.92-.55,.61-.82,1.43-.82,2.46s.27,1.85,.82,2.46c.55,.61,1.26,.92,2.14,.92,.55,0,1.03-.13,1.46-.38,.43-.26,.76-.63,1-1.12h3.14c-.33,1.27-1,2.27-1.99,3-.99,.73-2.19,1.1-3.58,1.1-1.14,0-2.16-.25-3.05-.76-.9-.51-1.6-1.21-2.1-2.12-.5-.9-.75-1.94-.75-3.1s.25-2.19,.75-3.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc);
export default __webpack_public_path__ + "static/media/dc.966d784651f37ff8c0b783c83bd2850c.svg";
export { ForwardRef as ReactComponent };